import { createClient } from "@supabase/supabase-js";
console.log("SupabaseClient.ts loaded!");

console.log("All envs:", import.meta.env);

export const supabase = createClient(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_ANON_KEY!,
    {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        },
    }
);

console.log("Supabase URL:", import.meta.env.VITE_SUPABASE_URL);
console.log(
    "Supabase ANON key starts with:",
    import.meta.env.VITE_SUPABASE_ANON_KEY?.slice(0, 6)
);

// 👇 TEMP: expose supabase for DevTools debugging
if (typeof window !== "undefined") {
    (window as any).supabase = supabase;
}